import * as React from 'react';

import {
  EmptyStateContainer,
  IconWrapper,
  Title,
  Message,
  CTAButton,
} from './EmptyPlansComponent.style';

type EmptyPlansComponentProps = {
  onContact?: () => void;
};

/**
 * EmptyPlansComponent
 * Displays an empty state when no plans are available
 * with visual guidance and a call-to-action button
 */
export const EmptyPlansComponent = ({
  onContact,
}: EmptyPlansComponentProps): JSX.Element => {
  const handleContactClick = () => {
    if (onContact) {
      onContact();
    } else {
      // Default behavior: scroll to top or show contact info
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  };

  return (
    <EmptyStateContainer>
      <IconWrapper>
        <i className="material-icons">assignment</i>
      </IconWrapper>
      <Title>Nenhum plano disponível</Title>
      <Message>
        Não encontramos nenhum plano público para você contratar. Entre em
        contato com a administração para mais informações.
      </Message>
      <CTAButton onClick={handleContactClick}>Entrar em contato</CTAButton>
    </EmptyStateContainer>
  );
};